<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon left>mdi-folder-multiple</v-icon>
        Edit Category
      </v-card-title>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="editedCategory.name"
            label="Category Name"
            :rules="[v => !!v || 'Category name is required']"
            required
            outlined
          ></v-text-field>
        </v-form>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancel</v-btn>
        <v-btn 
          color="primary" 
          @click="save" 
          :disabled="!valid"
          :loading="saving"
        >
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EditCategoryDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    category: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      valid: false,
      saving: false,
      editedCategory: {}
    }
  },
  computed: {
    dialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  watch: {
    value(newVal) {
      if (newVal) {
        this.editedCategory = { ...this.category }
      }
    }
  },
  methods: {
    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true
        try {
          await this.$emit('save', { ...this.editedCategory })
        } finally {
          this.saving = false
        }
      }
    },
    close() {
      this.$emit('close')
    }
  }
}
</script> 